/**
 * Page frame and page head. DESIGN.md §Layout: the page pads 32px top, clamp(16px,
 * 3.5vw, 48px) at the sides, 64px at the foot, capped at 1320px (max-w-7xl, 1280px, is
 * the nearest step); a page head is the 32px/700 heading (24px under 820px), a muted
 * 14px line under it and tools pushed right. The back link is DESIGN.md §Navigation's:
 * 14px/600 with a leading chevron and a 10px vertical hit pad.
 */
import React from "react";
import { Link } from "react-router-dom";
import StarsIcon from "../../styles/StarsIcon";
import { cn } from "./cn";

export function Page({ className, narrow = false, ...props }) {
  return (
    <div
      className={cn(
        "tw-w-full tw-px-4 tw-pt-8 tw-pb-16 md:tw-px-8 lg:tw-px-12 max-rail:tw-pt-6 tw-font-sans tw-text-text",
        narrow ? "tw-max-w-4xl" : "tw-max-w-7xl",
        className,
      )}
      {...props}
    />
  );
}

export function PageHead({ title, subtitle, tools, back, className }) {
  return (
    <div className={cn("tw-mb-8", className)}>
      {back && (
        <Link
          to={back.to}
          className="tw-mb-2 tw-inline-flex tw-items-center tw-gap-1 tw-py-2 tw-text-sm tw-font-semibold tw-text-link tw-no-underline hover:tw-text-link-hover"
        >
          <StarsIcon name="chevronLeft" className="tw-h-4 tw-w-4 tw-shrink-0" />
          {back.label}
        </Link>
      )}
      <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-4">
        <div className="tw-min-w-0">
          <h1 className="tw-m-0 tw-text-2xl tw-font-bold tw-text-text max-rail:tw-text-xl">
            {title}
          </h1>
          {subtitle && (
            <p className="tw-mb-0 tw-mt-1 tw-text-sm tw-text-text-muted">
              {subtitle}
            </p>
          )}
        </div>
        {tools && (
          <div className="tw-ml-auto tw-flex tw-flex-wrap tw-items-center tw-gap-2">
            {tools}
          </div>
        )}
      </div>
    </div>
  );
}
